/* eslint-disable ember/no-computed-properties-in-native-classes */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import moment from 'moment';
import type BehaviourDatesService from 'linced-app/services/behaviour-dates';

// Proto: attendance.Extension.
export default class Extension extends Fragment {
  declare [Type]: 'wellbeing/extension';

  @service
  declare behaviourDates: BehaviourDatesService;

  // initialEndDate is the initial end date of the suspension at the time of the extension
  @attr('string')
  declare initialEndDate: string | undefined;

  // newEndDate is the end date of the suspension after it has been extended
  @attr('string')
  declare newEndDate: string | undefined;

  // dayCount is the number of school days the suspension was extended by
  @attr('number', { defaultValue: 0 })
  declare dayCount: number;

  // approved is whether this extension has been approved by the DEL
  @attr('boolean', { defaultValue: false })
  declare approved: boolean;

  // reason contains the reason for the extension
  @attr('string', { defaultValue: '' })
  declare reason: string;

  // letterIds is the id of the letter correlating to this extension
  @attr('array')
  declare letterIds: string[] | undefined;

  @computed('newEndDate')
  get nextSchoolDay() {
    if (this.newEndDate === '') {
      return '';
    }
    // TS-STANDIN(behaviour-dates): service is JS, so getNextSchoolDay gives
    // any.
    return this.behaviourDates.getNextSchoolDay(
      moment(this.newEndDate, 'YYYY-MM-DD'),
      1,
    ) as string;
  }
}
